{
  /*  */
}

import React from 'react';
import { SVGProps } from '@/components/icon/Icon.types';

export const ListCheck = ({
  className,
  color = '#fff',
  width = 24,
  height = 24,
}: SVGProps) => {
  return (
    <svg
      width={width}
      height={height}
      className={className}
      focusable="false"
      aria-hidden="true"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
    >
      <path
        d="M14 10H3v2h11v-2Zm5-4H3v2h16V6ZM3 16h7v-2H3v2Zm18.5-4.5L23 13l-7 7-4.5-4.5L13 14l3 3 5.5-5.5Z"
        fill={color}
      />
    </svg>
  );
};
